import { styled } from '@mui/material/styles';
import { Button, Box, Container, Stack, Typography, Divider, List, ListItem, Grid } from '@mui/material';
import Sensor from './images/sensor_front.png';

const StyledImage = styled('img')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '93%',
});

export default function HeroBlock() {
  return (
    <Container sx={{ px: { lg: '0!important', xs: '32px!important' } }}>
      <Box sx={{ mt: 5, mb: 7, display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'space-between', flexDirection: { md: 'row', xs: 'column-reverse' } }}>
        <Box sx={{ maxWidth: '650px', width: '80vw' }}>
          <Typography
            variant="h2"
            sx={{ fontFamily: 'ZalandoSans', fontWeight: '800', fontSize: '60px !important', lineHeight: '1' }}
          >
            VPSi is a cutting- edge air quality monitoring system.
          </Typography>
          <Typography variant="h4" sx={{ mt: 2, mb: 4, fontFamily: 'ZalandoSans', fontWeight: '600' }}>
            Developed through pioneering research at NIOSH, patented at Purdue University, and proudly produced in the
            United States. VPSi is designed for precision, reliability, and real-world impact.
          </Typography>
          <Button
            color="error"
            variant="contained"
            size="xlarge"
            href="#solutions"
            sx={{
              fontWeight: '700',
              fontSize: '30px',
              borderRadius: '100px',
              padding: '10px 50px',
              fontFamily: 'ZalandoSans',
            }}
          >
            LEARN MORE
          </Button>
        </Box>
        <Box sx={{ maxWidth: '475px', width: '80vw', height: '80vw', maxHeight: '475px', position: 'relative' }}>
          <Box sx={{ bgcolor: 'action.selected', borderRadius: '50%', width: '100%', height: '100%' }} />
          <StyledImage src={Sensor} alt="VPSi Sensor" />
        </Box>
      </Box>
    </Container>
  );
}
